// extracted by mini-css-extract-plugin
export default {"btnpwd":"aa12831691"};